// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__hOLpS","fullwidth":"styles_fullwidth__bs_Ox","disabled":"styles_disabled__3D7E4"};